import { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../context/DataContext';

const UseLangLocation = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { myLang, setMyLang } = useContext(LangContext);

    useEffect(() => {
        const urlLang = location.pathname.split('/')[1];
        
        if (urlLang !== myLang && (urlLang === 'es' || urlLang === 'en' || urlLang === 'pt')) {
            // Actualizar idioma
            setMyLang(urlLang);
            
            // Forzar recarga
            const currentPath = location.pathname;
            navigate(currentPath, { replace: true, state: { forceReload: true } });
        }
    }, [location.pathname, myLang, setMyLang, navigate]);

    return children;
};

export default UseLangLocation;